/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { getAllNfts } from "../services/NftServices";
import { Link } from "react-router-dom";
import { FaCircleChevronLeft, FaCopy } from "react-icons/fa6";
import { BiChevronRight } from "react-icons/bi";
import NftCard from "../components/Nft/NftCard";
import { useNavigate } from "react-router-dom";
import Loader from "../components/loader/loader";
import NoData from "../components/NoDataComp/NoData";
import Pagination from "@mui/material/Pagination";
const debounceTime = 300;
let distinctUntilChanged = null;

const ViewAllNfts = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [nftData, setNftData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState("");
  const fetchNfts = async (
    pageNumber = page,
    pageSize = 12,
    search = filter
  ) => {
    try {
      setLoading(true);
      const response = await getAllNfts(pageNumber, pageSize, search);
      if (response.status === 200) {
        setLoading(false);
        setNftData(response.data.items);
        setTotalData(response?.data?.totalItems);
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching nft data:", error);
    }
  };
  const handleSearch = (val) => {
    const value = val.trim();
    setFilter(value);
    if (distinctUntilChanged) {
      clearTimeout(distinctUntilChanged);
      distinctUntilChanged = null;
    }
    distinctUntilChanged = setTimeout(() => {
      setFilter(value);
      fetchNfts(1, 8, value);
      distinctUntilChanged = null;
    }, debounceTime);
  };

  useEffect(() => {
    fetchNfts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          className="back-btn fw-500 text-black py-4"
          onClick={() => navigate(-1)}
        >
          <i className="pe-2 align-middle">
            <FaCircleChevronLeft />
          </i>
          Back
        </Link>
        <div>
          <input
            type="search"
            placeholder="Search NFT"
            style={{
              borderRadius: "12px",
              border: "none",
              padding: "5px 20px",
              background: "#d3d3d3a1",
            }}
            value={filter}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="dashboard-centerd">
          {nftData?.length > 0 ? (
            <div className="row g-0">
              <div className="row mb-4">
                {nftData?.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="col-xxl-4 col-xl-4 col-md-6 col-12 mb-4"
                    >
                      <NftCard
                        data={item}
                        fetchData={fetchNfts}
                        setLoading={setLoading}
                      />
                    </div>
                  );
                })}
              </div>
              {totalData > 12 && (
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    // minWidth: "200%",
                  }}
                >
                  <Pagination
                    color="primary"
                    count={Math.ceil(totalData / 12)}
                    page={page}
                    onChange={(e, v) => setPage(v)}
                    // activePage={page}
                  />
                </div>
              )}
            </div>
          ) : (
            <NoData />
          )}
        </div>
      )}
    </div>
  );
};

export default ViewAllNfts;
